var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPredictionNotPreferred = function SvgPredictionNotPreferred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.003 6.11 12 3l6.997 3.109.002.002.001.002v4.699c0 4.531-3.042 8.704-7 9.925-3.958-1.22-7-5.394-7-9.925V6.114l.001-.002zM21 6.112c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.51-.23-1.11-.23-1.62 0l-7 3.11C3.47 4.603 3 5.323 3 6.113v4.7c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12zM9.29 16.29 6.7 13.7a.996.996 0 1 1 1.41-1.41L10 14.17l5.88-5.88a.996.996 0 1 1 1.41 1.41l-6.59 6.59a.996.996 0 0 1-1.41 0",
    clipRule: "evenodd"
  })));
};
export default SvgPredictionNotPreferred;